// extracted by mini-css-extract-plugin
export default {"proj-card":"ProjectPage_proj-card__OYz7Q"};